import 'whatwg-fetch';

export default class TransportTypePrices {
	constructor(container, currency_switcher) {
		this.container = container;
		this.currency_switcher = currency_switcher;

		this.data = JSON.parse(this.container.dataset.transportTypePrices);

		this.transport_type_elements =
			this.container.querySelectorAll(this.data.selector);

		// this.directions =
		// 	container.querySelector('[data-directions]').directions;

		this.container.addEventListener('distance_updated', event => {
			const currency = this.currency_switcher.currency_code;

			fetch(`/api/v2/transport_types/prices?currency[code]=${currency}`)
				.then(response => response.json())
				.then(json => {
					this.transport_type_elements.forEach(transport_type_element => {
						const
							prices_element =
								transport_type_element.querySelector(this.data.prices.selector),
							transport_type_id =
								transport_type_element.querySelector('input').value;

						let min_price;
						if (typeof json.data == 'object') {
							min_price = json.data[transport_type_id];
						}

						if (min_price && event.detail) {
							const price_element =
								prices_element.querySelector('.convertable_price');
							price_element.dataset.currency = currency;
							price_element.dataset.value =
								Math.round(min_price * (event.detail / 1000));
							prices_element.classList.remove('hidden');
						} else {
							prices_element.classList.add('hidden');
						}
					});

					this.currency_switcher.update_currency();
				});
		});
	}
}
